// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","479":"component---src-templates-default-page-jsx","606":"component---src-templates-default-not-found-jsx"}[chunkId] || chunkId) + "-" + {"223":"29315ad89a2c0765a982","454":"3c13b1aef7fb6e1bc9a9","479":"fd29743af28493a58867","606":"0096c1ffd74445a71885"}[chunkId] + ".js";
};